import React from 'react';

interface PricingTier {
  name: string;
  price: string;
  period: string;
  features: string[];
  featured?: boolean;
}

const LandingPage: React.FC = () => {
  const pricingTiers: PricingTier[] = [
    {
      name: 'Free',
      price: '$0',
      period: '/month',
      features: [
        'Up to 10 clients',
        'Basic lead tracking',
        '5 work orders per month',
        'Email support'
      ]
    },
    {
      name: 'Standard',
      price: '$49',
      period: '/month',
      features: [
        'Up to 100 clients',
        'Advanced lead management',
        'Unlimited work orders',
        'Employee management',
        'Priority email support',
        'Basic reporting'
      ],
      featured: true
    },
    {
      name: 'Enterprise',
      price: '$99',
      period: '/month',
      features: [
        'Unlimited clients',
        'Full CRM features',
        'Advanced reporting',
        'API access',
        'Custom integrations',
        '24/7 phone support',
        'Dedicated account manager'
      ]
    }
  ];

  const handleSubscribe = (tier: string) => {
    localStorage.setItem('selectedTier', tier);
    window.location.href = '/payment';
  };

  return (
    <div>
      <nav className="navbar">
        <div className="container navbar-content">
          <div className="navbar-brand">HVAC CRM</div>
          <button 
            className="btn btn-secondary"
            onClick={() => window.location.href = '/login'}
          >
            Login
          </button>
        </div>
      </nav>

      <div className="container" style={{ padding: '60px 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h1 style={{ fontSize: '48px', marginBottom: '20px', color: '#2c3e50' }}>
            HVAC CRM Solutions
          </h1>
          <p style={{ fontSize: '20px', color: '#6c757d', maxWidth: '600px', margin: '0 auto' }}>
            Streamline your HVAC business with our comprehensive CRM platform. Manage leads, work orders, clients, and employees all in one place.
          </p>
        </div>

        <div className="pricing-grid">
          {pricingTiers.map((tier) => (
            <div key={tier.name} className={`pricing-card ${tier.featured ? 'featured' : ''}`}>
              <div className="pricing-header">
                <h3 className="pricing-title">{tier.name}</h3>
                <div className="pricing-price">{tier.price}</div>
                <div className="pricing-period">{tier.period}</div>
              </div>
              <div className="pricing-features">
                <ul>
                  {tier.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
                <button 
                  className="btn btn-primary"
                  onClick={() => handleSubscribe(tier.name)}
                  style={{ width: '100%' }}
                >
                  {tier.name === 'Free' ? 'Get Started' : 'Subscribe Now'}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '80px', padding: '60px 0', backgroundColor: 'white', borderRadius: '8px' }}>
          <h2 style={{ marginBottom: '40px', color: '#2c3e50' }}>Why Choose Our HVAC CRM?</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', marginTop: '40px' }}>
            <div>
              <h4 style={{ marginBottom: '15px', color: '#007bff' }}>Lead Management</h4>
              <p>Track and convert leads efficiently with our intuitive lead management system.</p>
            </div>
            <div>
              <h4 style={{ marginBottom: '15px', color: '#007bff' }}>Work Order Tracking</h4>
              <p>Manage maintenance and installation jobs from start to finish.</p>
            </div>
            <div>
              <h4 style={{ marginBottom: '15px', color: '#007bff' }}>Client Database</h4>
              <p>Keep detailed records of all your clients and their service history.</p>
            </div>
            <div>
              <h4 style={{ marginBottom: '15px', color: '#007bff' }}>Team Management</h4>
              <p>Organize your workforce and track employee performance.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;